<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">项目标题：</span>
        </div>
        <el-input v-model="formData.projectName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">项目说明：</span>
        </div>
        <el-input type="textarea" v-model="formData.projectExplain" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">项目模板：</span>
        </div>
        <el-select v-model="formData.templateCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择模板名称">
          <el-option v-for="item in templateList" :key="item.code"
                     :label="item.templateName" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">调查对象：</span>
        </div>
        <div @change="changeSpecify">
        <el-radio v-model="formData.specify" label='1' border>指定响应人</el-radio>
        </div>
        <div @change="changeSpecify">
        <el-radio v-model="formData.specify" label='0' border>园区所有人</el-radio>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text"></span>
        </div>
        <div v-if="formData.specify==1" >
          <div class="radio" @click="changeTarget">
            <el-radio v-model="formData.targetType" label="2">企业管理员</el-radio>
          </div>
          <div class="radio" @click="changeTarget">
            <el-radio v-model="formData.targetType" label="3">行政接口人</el-radio>
          </div>
          <div class="radio" @click="changeTarget">
            <el-radio v-model="formData.targetType" label="4">财务接口人</el-radio>
          </div>
          <div class="radio" @click="changeTarget">
            <el-radio v-model="formData.targetType" label="5">孵化接口人</el-radio>
          </div>
          <div class="radio" @click="changeTarget2" style="display:flex;align-items:center">
            <el-radio v-model="formData.targetType" label="6">自定义</el-radio>
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text"></span>
        </div>
         <div v-if="formData.specify=='1'">
          <div v-if="formData.targetType==6" style="font-size:14px">您已选择{{formData.personCodes.length}}位成员</div>
          <div v-else style="font-size:14px">您已选择{{formData.enterpriseCodes.length}}家企业</div>
         </div>
      </div>
      </form>

    <div class="form-btn-box">
      <button-confirm @confirm="confirm" />
      <button-cancel @cancel="cancel" />
    </div>

      <el-dialog
        title="企业盘点列表"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
        >
        <el-input placeholder="请输入企业名称" v-model="requestBody.searchKey" class="input-with-select" @keyup.13.native="getEnterpriseList" size="small" style="margin-bottom: 10px;">
        </el-input>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="formData.enterpriseCodes" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item,i) in enterpriseList" :label="item.code" :key="i" >{{item.enterpriseName}}</el-checkbox>
        </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmPublish">确 定</el-button>
      </span>
      </el-dialog>

    <el-dialog
      title="人员盘点列表"
      :visible.sync="dialogVisible2"
      width="40%"
      :before-close="handleClose"
      >
      <el-input placeholder="请输入人员名称" v-model="requestData.searchKey" class="input-with-select" @keyup.13.native="getPersonList" size="small" style="margin-bottom: 10px;">
      </el-input>
      <table-main :tableHeight="300" :tableHead="tableHead" :tableData="tableData" :relTableSelectData="formData.personCodes" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :hasOperation="false" @changePagination="changePagination" @changeSelection="changeSelection"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmPublish">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Questionnaire";
import { nError, nSuccess } from "../../../utils/notice";
import TableMain from "../../../components/Table/TableMain";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb,
    TableMain
  },
  name: "questionnaire-project-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "数据采集",
          name: "questionnaire-template-manage"
        },
        {
          value: "项目管理"
        }
      ],
      tableHead: [
        {
          prop: "name",
          label: "姓名"
        },
        {
          prop: "phone",
          label: "手机号"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        }
      ],
      mainTitle: "修改模板",
      subheading: "",
      tableData: [],
      requestData: {
        pageSize: 10,
        pageNum: 1,
        searchKey: ""
      },
      total: 0,
      formData: {
        projectName: "",
        projectExplain: "",
        templateCode: "",
        specify: "",
        targetType: "",
        allEnterprise: false,
        templateName: "",
        enterpriseCodes: [],
        personCodes: []
      },
      requestBody: {
        searchKey: ""
      },
      dialogVisible: false,
      dialogVisible2: false,
      templateList: [],
      enterpriseList: [],
      personList: [],
      checkAll: false,
      isIndeterminate: false,
      templateCodes: ""
      // enterpriseCodes: ""
    };
  },
  created() {
    this.remoteMethod();
    this.getEnterpriseList();
    // this.getPersonList();
    // this.getProjectByCode();
  },
  mounted() {
    this.getPersonList();
  },
  methods: {
    //查询
    getProjectByCode() {
      this.$axios
        .get(`${api.getProjectByCode}/${this.$route.params.id}`, {})
        .then(res => {
          console.log(res.data.data);
          if (res.data.retCode === 1) {
            this.formData = res.data.data;
            if (!this.formData.enterpriseCodes) {
              this.formData.enterpriseCodes = [];
            }
            if (this.formData.specify == true) {
              this.formData.specify = "1";
            } else if (this.formData.specify == false) {
              this.formData.specify = "0";
            }
            if (this.formData.allEnterprise === true) {
              this.enterpriseList.map(item => {
                this.formData.enterpriseCodes.push(item.code);
              });
            }
          }
        })
        .catch(errorHandler("查询失败"));
    },
    remoteMethod(query) {
      this.getTemplateList(query);
    },
    getTemplateList(searchKey) {
      this.$axios
        .post(api.getTemplateList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            this.templateList = list;
          }
        })
        .catch(errorHandler("获取模板列表失败"));
    },
    getEnterpriseList() {
      this.$axios
        .post(api.getEnterpriseList, this.requestBody)
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            this.enterpriseList = list;
            this.getProjectByCode();
          }
        })
        .catch(errorHandler("获取企业列表失败"));
    },
    getPersonList() {
      this.$axios
        .post(api.getPersonList, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data.list;
            this.tableData = list;
            this.total = res.data.data.total;
            this.personList = list;
          }
        })
        .catch(errorHandler("获取人员列表失败"));
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPersonList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    changeSelection(codeArr) {
      this.formData.personCodes = codeArr;
      console.log(this.formData.personCodes);
    },
    handleCheckAllChange(val) {
      this.formData.enterpriseCodes = [];
      this.enterpriseList.map(item => {
        this.formData.enterpriseCodes.push(item.code);
      });
      this.formData.enterpriseCodes = val ? this.formData.enterpriseCodes : [];
      this.isIndeterminate = false;
      if (val === true) {
        this.formData.allEnterprise = true;
      } else {
        this.formData.allEnterprise = false;
      }
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.enterpriseList.length;
      if (this.checkAll === true) {
        this.formData.allEnterprise = true;
      } else {
        this.formData.allEnterprise = false;
      }
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.enterpriseList.length;
    },
    handleCheckAllChange2(val) {
      this.personList.map(item => {
        this.formData.personCodes.push(item.code);
      });
      this.formData.personCodes = val ? this.formData.personCodes : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange2(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.personList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.personList.length;
    },
    confirmPublish() {
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    changeTarget() {
      this.dialogVisible = true;
      this.getPersonList();
    },
    changeTarget2(e) {
      if (e.target.localName === "input") return;
      this.dialogVisible2 = true;
    },
    changeSpecify() {
      this.formData.enterpriseCodes = [];
      this.formData.personCodes = [];
    },
    confirm() {
      if (!this.formData.projectName) {
        nError("请输入项目标题");
        return false;
      }
      if (!this.formData.templateCode) {
        nError("请选择调查模板");
        return false;
      }
      if (!this.formData.specify) {
        nError("请选择调查对象");
        return false;
      }
      if (
        this.formData.specify === "1" &&
        this.formData.enterpriseCodes.length === 0 &&
        this.formData.personCodes.length === 0
      ) {
        nError("请选择调查对象");
        return false;
      }
      if (this.formData.specify == 1) {
        this.formData.specify = true;
      } else {
        this.formData.specify = false;
      }
      this.$axios
        .post(api.updateProject, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.$router.push({
              name: "questionnaire-project-manage"
            });
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.$router.push({
        name: "questionnaire-project-manage"
      });
    }
  },
  watch: {
    // templateCodes(val) {
    //   this.templateList.map(v => {
    //     if (v.code === val) {
    //       this.formData.templateCode = v.code;
    //       this.formData.templateName = v.templateName;
    //     }
    //   });
    // },
    "formData.targetType": {
      handler(val, oldVal) {
        if (val != oldVal && oldVal) {
          this.checkAll = false;
          this.formData.enterpriseCodes = [];
          this.formData.personCodes = [];
          this.isIndeterminate = false;
        }
      },
      deep: true
    }
    // "formData.allEnterprise": {
    //   handler(val) {
    //     console.log(val);
    //     if (!this.formData.enterpriseCodes) {
    //       this.formData.enterpriseCodes = [];
    //     }
    //     if (val === true) {
    //       this.enterpriseList.map(item => {
    //         this.formData.enterpriseCodes.push(item.code);
    //       });
    //     }
    //   },
    //   deep: true
    // }
  }
};
</script>

<style scoped>
.radio {
  margin-right: 20px;
}
.el-checkbox-group {
  height: 200px;
  overflow-y: auto;
}
.el-checkbox {
  width: 100%;
  text-align: start;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Questionnaire/QuestionnaireProject/QuestionnaireProjectModify.vue